
import { actionTypes } from './constants';
import { getApiActionCreator } from 'helpers/actionHelper';

export const getConnectionHistoryAsset = (assetId) => {
    return {
        type: actionTypes.GET_CONNECTION_HISTORY_ASSET,
        payload: {
            assetId
        }
    };
};

export const getRssiHistoryAction = getApiActionCreator(actionTypes.GET_RSSI_HISTORY_SETTINGS);

export const getRssiHistory = (sensorId) => {
    return {
        type: actionTypes.GET_RSSI_HISTORY,
        payload: {
            sensorId
        }
    };
};

export const clearRssiHistory = () => {
    return {
        type: actionTypes.CLEAR_RSSI_HISTORY
    };
};
